import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  programmauswahl: boolean;
  einmaleins: boolean;
  einspluseins: boolean;
  einsdurcheins: boolean;
  neuprogramm: boolean;

  private setEinmaleins() {
    this.programmauswahl = true;
    this.einmaleins = false;
    this.einspluseins = true;
    this.einsdurcheins = true;
    this.neuprogramm = false;
  }

  private setEinspluseins() {
    this.programmauswahl = true;
    this.einmaleins = true;
    this.einspluseins = false;
    this.einsdurcheins = true;
    this.neuprogramm = false;
  }

  private setEinsdurcheins() {
    this.programmauswahl = true;
    this.einmaleins = true;
    this.einspluseins = true;
    this.einsdurcheins = false;
    this.neuprogramm = false;
  }

  private programm_neu() {
    this.programmauswahl = false;
    this.einmaleins = true;
    this.einspluseins = true;
    this.einsdurcheins = true;
    this.neuprogramm = true;
}

  constructor() {
  }

  ngOnInit() {
    this.programmauswahl = false;
    this.einmaleins = true;
    this.einspluseins = true;
    this.einsdurcheins = true;
    this.neuprogramm = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts